"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var indirectEval = process.env.NODE_ENV === 'production' ? function () { return 0; } : eval;
var doesSupportClasses = 1 && (function () {
    try {
        if (indirectEval('(function(){ return class TestClassSupport {} })()')) {
            return true;
        }
    }
    catch (e) {
    }
    return false;
})();
var ES6ProxyComponentFactory = (doesSupportClasses &&
    indirectEval("(function(InitialParent) {return class ProxyComponent extends InitialParent {}})"));
var ES5ProxyComponentFactory = function (InitialParent) {
    function ProxyComponent() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        InitialParent.call.apply(InitialParent, [this].concat(args));
    }
    ProxyComponent.prototype = Object.create(InitialParent.prototype);
    Object.setPrototypeOf(ProxyComponent, InitialParent);
    return ProxyComponent;
};
function safeDefine(target, key, descriptor) {
    try {
        Object.defineProperty(target, key, descriptor);
    }
    catch (e) {
    }
}
exports.safeDefine = safeDefine;
function transferProperties(source, target) {
    var keys = Object.getOwnPropertyNames(source);
    keys.forEach(function (key) { return safeDefine(target, key, Object.getOwnPropertyDescriptor(source, key)); });
}
function classDuplicator(comp) {
    var dupe = (doesSupportClasses
        ? ES6ProxyComponentFactory
        : ES5ProxyComponentFactory)(comp);
    transferProperties(comp, dupe);
    return comp;
}
exports.classDuplicator = classDuplicator;
